module.exports = __webpack_public_path__ + "img/numberOne.eac7460d.png";